module.exports = __webpack_public_path__ + "img/24.bcb97fce.gif";